import { render, staticRenderFns } from "./ShipperOrgListPage.vue?vue&type=template&id=649a6b10&"
import script from "./ShipperOrgListPage.vue?vue&type=script&lang=js&"
export * from "./ShipperOrgListPage.vue?vue&type=script&lang=js&"
import style0 from "./ShipperOrgListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports